import React from 'react';
import BaseProps from "../../../types/BaseProps";
// @ts-ignore
import Pagination from 'react-js-pagination';

import "./SearchPagination.scss";

type SearchPaginationProps = {
  // total amount of search result items
  total: number;
  // Currently active/selected page
  currentPage: number;
  // items count per page
  pageSize: number;
  // handler for page change event
  onPage: (page: number) => void;
  disabled: boolean
};

/**
 * Component wrapper for the pagination library.
 */
class SearchPagination extends React.Component<SearchPaginationProps & BaseProps> {

  /**
   * How many pages to be visible in the pagination component.
   * @type {number}
   */
  private static readonly PAGE_RANGE: number = 5;

  onPageChange = (page: any) => {
    if (!this.props.disabled) {
      this.props.onPage(page);
    }
  };

  render() {
    const currentPage = this.props.currentPage;
    const itemsCountPerPage = this.props.pageSize;
    const totalItems = this.props.total;
    const pageRange = SearchPagination.PAGE_RANGE;

    return (
      <div className="SearchPagination d-flex justify-content-center">
        <Pagination
          activePage={currentPage}
          itemsCountPerPage={itemsCountPerPage}
          totalItemsCount={totalItems}
          pageRangeDisplayed={pageRange}
          itemClass="page-item"
          linkClass="page-link"
          onChange={this.onPageChange}
        />
      </div>
    );
  }
}

export default SearchPagination;
